import PreQualificationRestApi from 'api/PreQualificationApi';
import LoanOfferRestApi from 'api/LoanOfferApi';
import PreQualificationDeclineRestApi from 'api/PreQualificationDeclineApi';
import DocuSignEnvelopeRestApi from 'api/DocuSignEnvelopeApi';
import ApplicationDataRestApi from 'api/ApplicationDataApi';
import ApplicationDocumentsRestApi from 'api/DocumentsApi';
import EmployersApi from 'api/EmployersApi';
import PlaidRestApi from 'api/PlaidApi';
import EmailRestApi from 'api/EmailApi';
import PaymentAccountRestApi from 'api/PaymentAccountApi';
import MethodRestApi from 'api/MethodApi';
import CardRestApi from 'api/CardApi';
import ACHPaymentApi from 'api/PaymentApi';
import AuthRestApi from 'api/AuthApi';
import AlloyRestApi from 'api/AlloyApi';
import StudentLoanRestApi from 'api/StudentLoanApi';
import PaycheckSwitchRestApi from 'api/PaycheckSwitchApi';
import ReportsRestApi from 'api/ReportsApi';
import PayoffApiService from 'api/PayoffApi';
import GoalOptimizerApi from 'api/GoalOptimizerApi';
import ShiftWizardRestApi from 'api/ShiftWizardApi';
import FinancialMetricsRestApi from 'api/FinancialMetricsApi';
import AICoachGoalsRestApi from 'api/AICoachGoalsApi';
import AICoachShiftImpactRestApi from 'api/AICoachShiftImpactApi';
import AICoachConversationRestApi from 'api/AICoachConversationApi';
import ReferralRestApi from 'api/ReferralApi';

import { getPlanneryApiUrl } from 'utils/getApiUrls';

import { createLoanOfferThunk } from './createLoanOfferThunk';
import { createUpdateLoanOfferThunk } from './createUpdateLoanOfferThunk';
import { createUpdateOfferWithVerifiedIncomeThunk } from './createUpdateOfferWithVerifiedIncomeThunk';
import { createLoanOfferXSellThunk } from './createLoanOfferXSellThunk';
import { createPreQualificationDeclineThunk } from './createPreQualificationDeclineThunk';
import { createDocuSignEnvelopeThunk } from './createDocuSignEnvelopeThunk';
import { createGetApplicationDataThunk } from './createGetApplicationDataThunk';
import { createBankAccountThunk } from './createBankAccountThunk';
import { createUploadDocumentsThunk } from './createUploadDocumentsThunk';
import { createUploadStudentAidDataThunk } from './createUploadStudentAidDataThunk';
import { createApplicationStatusThunk } from './createApplicationStatusThunk';
import { createUserLocationThunk } from './createUserLocationThunk';
import { createLinkTokenThunk } from './createLinkTokenThunk';
import { createSendPlaidSuccessThunk } from './createSendPlaidSuccessThunk';
import { createValidateIdentityThunk } from './createValidateIdentityThunk';
import { createExchangePublicTokenThunk } from './createExchangePublicTokenThunk';
import { createCreateApplicationThunk } from './createCreateApplicationThunk';
import { createGetCheckingAccounts } from './createGetCheckingAccountsThunk';
import { createUpdateApplicationCheckingAccountThunk } from './createUpdateApplicationCheckingAccountThunk';
import { createSendOfferComparisonEmailThunk } from './createSendOfferComparisonEmail';
import { createFeedbackThunk } from './createFeedbackThunk';
import { createPaymentAccountCreationThunk } from './createPaymentAccountCreationThunk';
import { createGetPaymentAccountThunk } from './createGetPaymentAccountThunk';
import { createIdentityDataThunk } from './createIdentityDataThunk';
import { createExtendedIdentityCheckThunk } from './createExtendedIdentityCheckThunk';
import { createUpdateCurrentFlowThunk } from './createUpdateCurrentFlowThunk';
import { createUpdateEmploymentDataThunk } from './createUpdateEmploymentDataThunk';
import { createGetEmployerData } from './createGetEmployerDataThunk';
import { createSendDirectDepositEnrollmentFormEmail } from './createSendEnrollmentFormEmailThunk';
import { createSendStudentLoanEnrollmentFormEmail } from './createSendStudentLoanEnrollmentFormEmailThunk';
import { createUpdateSelectedTradelinesThunk } from './createUpdateSelectedTradelinesThunk';
import { createSetRecommendationStrategyThunk } from './createSetRecommendationStrategyThunk';
import { createUpdateAdditionalFundsThunk } from './createUpdateAdditionalFundsThunk';
import { createUpdatePaymentMethodThunk } from './createUpdatePaymentMethodThunk';
import { createElementTokenThunk, createAuthSessionThunk } from './createMethodThunk';
import { createLoanManagementThunk } from './createLoanManagementThunk';
import { createPreVerifyApplicationThunk, createVerifyApplicationThunk } from './createVerifyApplicationThunk';
import { createCardJoinWaitListThunk, createCardJoinWaitListWithLoanOfferThunk } from './createCardApplyThunk';
import { createACHPaymentThunk } from './createACHPaymentThunk';
import { createGetCardDataForLoanApplication } from './createGetCardDataForLoanApplicationThunk';
import { createGetApplicationAprThunk } from './createGetApplicationAprThunk';
import {
  createAuthAuthSessionThunk,
  createAuthOtpThunk,
  createReapplyThunk,
  createAuthSendSmsCodeForApplicationId,
  createAuthSendSmsCodeThunk,
  createAuthSendEmailCodeThunk,
} from './createAuthThunk';
import { createHStreamCallbackThunk } from './createHStreamAuthThunk';
import { createAlloyKycThunk } from './createAlloyThunk';
import { createStudentLoanAssistanceDataThunk } from './createStudentLoanAssistanceDataThunk';
import { createUpdateStudentLoanAssistanceDataThunk } from './createUpdateStudentLoanAssistanceDataThunk';
import { createGetPaycheckSwitchOfferThunk } from './createGetPaycheckSwitchOfferThunk';
import { createGetStudentLoanApplicationThunk } from './createGetStudentLoanApplicationThunk';
import { createUpdateStudentLoanApplicationThunk } from './createUpdateStudentLoanApplicationThunk';
import { createUploadPaystubsThunk } from './createUploadPaystubsThunk';
import { createSignEcfThunk } from './createSignEcfThunk';
import { createUploadEnrollmentFormThunk } from './createUploadEnrollmentFormThunk';
import { createPreviewEcfThunk } from './createPreviewEcfThunk';
import { createGetLatestLoanPaymentThunk } from './createGetLatestLoanPaymentThunk';
import { createGetOffersThunk } from './createGetOffersThunk';
import { createSaveSelectedOfferThunk } from './createSaveSelectedOfferThunk';
import { createGetAmountPerPaycheckThunk } from './createGetAmountPerPaycheckThunk';
import { createGetGoalProgressThunk } from './createGetGoalProgressThunk';
import { createGetNextStepsThunk } from './createGetNextStepsThunk';
import { createGetCreditScoreHistoryThunk } from './createGetCreditScoreHistoryThunk';
import { createValidateEmployerProvidedIncomeThunk } from './createValidateEmployerProvidedIncomeThunk';
import { createGetAdditionalFundsThunk } from './createGetAdditionalFundsThunk';
import { createUpdatePayrollProviderToManualThunk } from './createUpdatePayrollProviderToManualThunk';
import { createGetLoanBreakdownThunk } from './createGetLoanBreakdownThunk';
import { createGetPayoffPaymentsThunk } from './createGetPayoffPaymentsThunk';
import { createExplainThunk, createParaphraseThunk, createRecommendThunk } from './createGoalOptimizerThunk';
import { createGetAvailableShiftsThunk } from './createGetAvailableShiftsThunk';
import { createRequestShiftThunk } from './createRequestShiftThunk';
import { createGetShiftImpactThunk } from './createGetShiftImpactThunk';
import { createPostCoachConversationThunk } from './createPostCoachConversationThunk';
import { createGetFinancialMetricsThunk } from './createGetFinancialMetricsThunk';
import { createGetAICoachGoalsThunk } from './createGetAICoachGoalsThunk';
import { createCreateAICoachGoalsThunk } from './createCreateAICoachGoalsThunk';
import { createUpdateAICoachGoalsThunk } from './createUpdateAICoachGoalsThunk';
import { createStartScoreImprovementPlanThunk } from './createStartScoreImprovementPlanThunk';
import { createGetSavingsAccountsThunk } from './createGetSavingsAccountsThunk';
import { createGetParaphraseNextStepThunk } from './createGetParaphraseNextStepThunk';
import { createGetUpcomingLoanPaymentsThunk } from './createGetUpcomingLoanPaymentsThunk';
import { createGetReferralLinkThunk } from './createGetReferralLinkThunk';

const apiUrl = getPlanneryApiUrl();

const applicationApi = new ApplicationDataRestApi(apiUrl);
export const getApplicationData = createGetApplicationDataThunk(applicationApi);
export const getApplicationApr = createGetApplicationAprThunk(applicationApi);
export const createApplication = createCreateApplicationThunk(applicationApi);
export const updateApplicationBankAccountData = createBankAccountThunk(applicationApi);
export const updateApplicationStatus = createApplicationStatusThunk(applicationApi);
export const updateApplicationCheckingAccount = createUpdateApplicationCheckingAccountThunk(applicationApi);
export const updateApplicationFeedbackData = createFeedbackThunk(applicationApi);
export const updateApplicationLoanManagementData = createLoanManagementThunk(applicationApi);
export const updateIdentityData = createIdentityDataThunk(applicationApi);
export const updateExtendedIdentityCheck = createExtendedIdentityCheckThunk(applicationApi);
export const updateApplicationCurrentFlow = createUpdateCurrentFlowThunk(applicationApi);
export const updateEmploymentData = createUpdateEmploymentDataThunk(applicationApi);
export const updateSelectedTradelines = createUpdateSelectedTradelinesThunk(applicationApi);
export const setRecommendationStrategy = createSetRecommendationStrategyThunk(applicationApi);
export const updateAdditionalFunds = createUpdateAdditionalFundsThunk(applicationApi);
export const updatePaymentMethod = createUpdatePaymentMethodThunk(applicationApi);
export const getLatestLoanPayment = createGetLatestLoanPaymentThunk(applicationApi);
export const getLoanBreakdown = createGetLoanBreakdownThunk(applicationApi);
export const getAdditionalFunds = createGetAdditionalFundsThunk(applicationApi);
export const getUpcomingLoanPayments = createGetUpcomingLoanPaymentsThunk(applicationApi);

const alloyApi = new AlloyRestApi(apiUrl);
export const alloyKyc = createAlloyKycThunk(alloyApi);

const authApi = new AuthRestApi(apiUrl);
export const authSession = createAuthAuthSessionThunk(authApi);
export const authOtp = createAuthOtpThunk(authApi);
export const reapply = createReapplyThunk(authApi);
export const sendSmsCode = createAuthSendSmsCodeThunk(authApi);
export const sendEmailCode = createAuthSendEmailCodeThunk(authApi);
export const hstreamCallback = createHStreamCallbackThunk(authApi);

const cardApi = new CardRestApi(apiUrl);
export const joinCardWaitList = createCardJoinWaitListThunk(cardApi);
export const joinCardWaitListWithLoanOffer = createCardJoinWaitListWithLoanOfferThunk(cardApi);
export const getCardDataForLoanApplication = createGetCardDataForLoanApplication(cardApi);

const docuSignEnvelopeApi = new DocuSignEnvelopeRestApi(apiUrl);
export const createDocuSignEnvelope = createDocuSignEnvelopeThunk(docuSignEnvelopeApi);

const documentsApi = new ApplicationDocumentsRestApi(apiUrl);
export const uploadDocuments = createUploadDocumentsThunk(documentsApi);

const emailApi = new EmailRestApi(apiUrl);
export const sendOfferComparisonEmail = createSendOfferComparisonEmailThunk(emailApi);
export const sendDirectDepositEnrollmentFormEmail = createSendDirectDepositEnrollmentFormEmail(emailApi);
export const sendStudentLoanEnrollmentForm = createSendStudentLoanEnrollmentFormEmail(emailApi);

const employersApi = new EmployersApi(apiUrl);
export const getEmployerData = createGetEmployerData(employersApi);
export const validateEmployerProvidedIncome = createValidateEmployerProvidedIncomeThunk(employersApi);
export const updatePayrollProviderToManual = createUpdatePayrollProviderToManualThunk(employersApi);

const loanOfferApi = new LoanOfferRestApi(apiUrl);
export const getLoanOffer = createLoanOfferThunk(loanOfferApi);
export const updateLoanOffer = createUpdateLoanOfferThunk(loanOfferApi);
export const updateOfferWithVerifiedIncome = createUpdateOfferWithVerifiedIncomeThunk(loanOfferApi);
export const getLoanOfferXSell = createLoanOfferXSellThunk(loanOfferApi);
export const preVerifyApplication = createPreVerifyApplicationThunk(loanOfferApi);
export const verifyApplication = createVerifyApplicationThunk(loanOfferApi);

const aiCoachGoalsApi = new AICoachGoalsRestApi(apiUrl);
export const getAICoachGoals = createGetAICoachGoalsThunk(aiCoachGoalsApi);
export const createAICoachGoals = createCreateAICoachGoalsThunk(aiCoachGoalsApi);
export const updateAICoachGoals = createUpdateAICoachGoalsThunk(aiCoachGoalsApi);
export const startScoreImprovementPlan = createStartScoreImprovementPlanThunk(aiCoachGoalsApi);
export const getGoalProgress = createGetGoalProgressThunk(aiCoachGoalsApi);
export const getNextSteps = createGetNextStepsThunk(aiCoachGoalsApi);
export const paraphraseNextStep = createGetParaphraseNextStepThunk(aiCoachGoalsApi);

const methodApi = new MethodRestApi(apiUrl);
export const elementTokenThunk = createElementTokenThunk(methodApi);
export const authSessionThunk = createAuthSessionThunk(methodApi);

const paycheckSwitchApi = new PaycheckSwitchRestApi(apiUrl);
export const getPaycheckSwitchOffer = createGetPaycheckSwitchOfferThunk(paycheckSwitchApi);

const paymentAccountApi = new PaymentAccountRestApi(apiUrl);
export const createPaymentAccount = createPaymentAccountCreationThunk(paymentAccountApi);
export const getPaymentAccount = createGetPaymentAccountThunk(paymentAccountApi);

const paymentApi = new ACHPaymentApi(apiUrl);
export const makeACHPayment = createACHPaymentThunk(paymentApi);

const plaidApi = new PlaidRestApi(apiUrl);
export const getLinkToken = createLinkTokenThunk(plaidApi);
export const sendPlaidSuccess = createSendPlaidSuccessThunk(plaidApi);
export const validateIdentity = createValidateIdentityThunk(plaidApi);
export const getCheckingAccounts = createGetCheckingAccounts(plaidApi);
export const exchangePublicToken = createExchangePublicTokenThunk(plaidApi);
export const getSavingsAccounts = createGetSavingsAccountsThunk(plaidApi);

const preQualificationApi = new PreQualificationRestApi(apiUrl);
export const getUserLocation = createUserLocationThunk(preQualificationApi);

const preQualificationDeclineApi = new PreQualificationDeclineRestApi(apiUrl);
export const sendNotification = createPreQualificationDeclineThunk(preQualificationDeclineApi);

const studentLoanApi = new StudentLoanRestApi(apiUrl);
export const uploadStudentAidData = createUploadStudentAidDataThunk(studentLoanApi);
export const uploadPaystubs = createUploadPaystubsThunk(studentLoanApi);
export const uploadEnrollmentForm = createUploadEnrollmentFormThunk(studentLoanApi);
export const getStudentLoanAssistanceData = createStudentLoanAssistanceDataThunk(studentLoanApi);
export const updateStudentLoanAssistanceData = createUpdateStudentLoanAssistanceDataThunk(studentLoanApi);
export const getStudentLoanApplication = createGetStudentLoanApplicationThunk(studentLoanApi);
export const updateStudentLoanApplication = createUpdateStudentLoanApplicationThunk(studentLoanApi);
export const sendSmsCodeForApplicationId = createAuthSendSmsCodeForApplicationId(authApi);
export const signEcf = createSignEcfThunk(studentLoanApi);
export const previewEcf = createPreviewEcfThunk(studentLoanApi);

const reportsApi = new ReportsRestApi(apiUrl);
export const getOffers = createGetOffersThunk(reportsApi);
export const saveSelectedOffer = createSaveSelectedOfferThunk(reportsApi);
export const getAmountPerPaycheck = createGetAmountPerPaycheckThunk(reportsApi);
export const getCreditScoreHistory = createGetCreditScoreHistoryThunk(reportsApi);

const payoffApi = new PayoffApiService(apiUrl);
export const getPayoffPayments = createGetPayoffPaymentsThunk(payoffApi);

const goalOptimizerApi = new GoalOptimizerApi(apiUrl);
export const recommendGoal = createRecommendThunk(goalOptimizerApi);
export const explainGoal = createExplainThunk(goalOptimizerApi);
export const paraphraseGoal = createParaphraseThunk(goalOptimizerApi);

const shiftWizardApi = new ShiftWizardRestApi(apiUrl);
export const getAvailableShifts = createGetAvailableShiftsThunk(shiftWizardApi);
export const requestShift = createRequestShiftThunk(shiftWizardApi);

const aiCoachShiftImpactApi = new AICoachShiftImpactRestApi(apiUrl);
export const getShiftImpact = createGetShiftImpactThunk(aiCoachShiftImpactApi);

const aiCoachConversationApi = new AICoachConversationRestApi(apiUrl);
export const postAiCoachConversation = createPostCoachConversationThunk(aiCoachConversationApi);

const financialMetricsApi = new FinancialMetricsRestApi(apiUrl);
export const getFinancialMetrics = createGetFinancialMetricsThunk(financialMetricsApi);

const referralApi = new ReferralRestApi(apiUrl);
export const getReferralLink = createGetReferralLinkThunk(referralApi);
